<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <hm-alert />
        <p>
          Identify all forms of electronic protected health information (ePHI) media
          <hm-popover title="Electronic media is defined in &sect;160.103, as:">
            &quot;(1) Electronic storage media including memory devices in computers (hard drives) and any removable/transportable digital memory medium, such as magnetic tape or disk, optical disk, or digital memory card; or (2) Transmission media
            used to exchange information already in electronic storage media. Transmission media include, for example, the internet (wide-open), extranet (using internet technology to link a business with information accessible only to collaborating parties),
            leased lines, dial-up lines, private networks, and the physical movement removable/transportable electronic storage media. Certain transmissions, including of paper, via facsimile, and of voice, via telephone, are not considered to be transmissions
            via electronic media, because the information being exchanged did not exist in electronic form before the transmission.&quot;
          </hm-popover>within your practice. When building your media list consider all business activities that create, store, and transmit ePHI and the information systems supporting these processes.
        </p>
        <hm-spinner v-if="!ready" />
      </b-col>
    </b-row>

    <b-row v-show="ready">
      <b-col>
        <b-button type="button" variant="primary" class="px-4" to="/inventory-edit">Add Media</b-button>
      </b-col>
    </b-row>

    <b-row class="pt-4" v-show="ready">
      <b-col>
        <b-table class="p-1" responsive bordered hover show-empty empty-text="No Inventory Items" :items="inventory" :fields="columns" :sort-compare="sortCompare" @row-clicked="rowClick" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { inventoryService } from '@/services'
import Enumerable from 'linq/linq.js'

export default {
  name: 'InventoryList',
  data() {
    return {
      inventory: [],
      columns: [{
        key: 'name',
        label: 'Name',
        sortable: true
      }, {
        key: 'type',
        label: 'Type',
        sortable: true,
        formatter: (value, key, item) => {
          return this.inventoryMap.Type[value];
        }
      }, {
        key: 'location',
        label: 'Location',
        sortable: true
      }, {
        key: 'assignee',
        label: 'Assignee',
        sortable: true
      }],
      ready: false
    }
  },
  computed: {
    ...mapState('maps', ['inventoryMap'])
  },
  methods: {
    ...mapActions({
      alertException: 'alert/exception'
    }),
    sortCompare(a, b, key) {
      if (key === 'type') { // custom sorting for the 'type' column
        return this.inventoryMap.Type[a[key]].localeCompare(this.inventoryMap.Type[b[key]]);
      }
      if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0
      }
      return String(a[key]).localeCompare(String(b[key]));
    },
    rowClick(record, index) {
      this.$router.push({ name: 'InventoryEdit', params: { id: record.id } });
    }
  },
  created() {
    this.ready = false;

    Promise.all([
      this.$store.dispatch('maps/fetchInventoryMap'),
      inventoryService.getInventory()
    ]).then((values) => {
      this.inventory = values[1];
    }).catch((err) => {
      this.alertException({ err, message: 'Error loading data.' });
    }).finally(() => {
      this.ready = true;
    })
  }
}
</script>
